import {
  LISTING_ACCESSOR_KEYS,
  StrCatalog,
  validateStrCatalogSearch,
} from "@/components/non_registrant/str-catalog";
import { getJurisdictionsOptions } from "@/hera-api/client/@tanstack/react-query.gen";
import { useAuthQuerySetup } from "@/hooks/use-auth-query-setup";
import { useOperatorDashboardState } from "@/hooks/use-operator-dashboard-state";
import { useRegionFilterOptions } from "@/hooks/use-region-filter";
import { useQuery } from "@tanstack/react-query";
import { createFileRoute } from "@tanstack/react-router";

export const Route = createFileRoute("/operator/str_/listings")({
  validateSearch: (search: Record<string, unknown>) =>
    validateStrCatalogSearch(search, "platform", LISTING_ACCESSOR_KEYS),
  component: ListingsRoute,
});

function ListingsRoute() {
  const search = Route.useSearch();
  const navigate = Route.useNavigate();
  const { isAuthSetupComplete } = useAuthQuerySetup();
  const dashboardState = useOperatorDashboardState();
  const jurisdictionsQuery = useQuery({
    ...getJurisdictionsOptions({ query: { include_deleted: false } }),
    enabled: isAuthSetupComplete,
  });
  const jurisdictions = jurisdictionsQuery.data?.jurisdictions ?? [];
  const regionScope = jurisdictions.filter(
    (jurisdiction) =>
      dashboardState.selectedJurisdictions.length === 0 ||
      dashboardState.selectedJurisdictions.includes(jurisdiction.id),
  );
  const regionFilter = useRegionFilterOptions({
    jurisdictionIds: regionScope.map((jurisdiction) => jurisdiction.id),
    jurisdictionNames: Object.fromEntries(
      regionScope.map((jurisdiction) => [jurisdiction.id, jurisdiction.name]),
    ),
    enabled: isAuthSetupComplete,
  });
  return (
    <div className="flex min-h-0 flex-1 flex-col overflow-hidden">
      <StrCatalog
        kind="listings"
        search={search}
        onSearchChange={(next) => {
          void navigate({ search: next, replace: true });
        }}
        sharedFilters={{
          columnFilters: dashboardState.columnFilters,
          setColumnFilters: dashboardState.setColumnFilters,
          selectedJurisdictions: dashboardState.selectedJurisdictions,
          setSelectedJurisdictions: dashboardState.setSelectedJurisdictions,
          jurisdictions: jurisdictions.map((jurisdiction) => ({
            id: jurisdiction.id,
            name: jurisdiction.name,
          })),
          selectedRegions: dashboardState.selectedRegions,
          setSelectedRegions: dashboardState.setSelectedRegions,
          regions: regionFilter.catalog,
        }}
      />
    </div>
  );
}
